module.exports = __webpack_public_path__ + "img/file-img.d89efce1.svg";